export default "__VITE_ASSET__CavQB0zH__"